import { create } from 'zustand';
import type { MeResponse } from '@client/api/me';

type AuthState = {
  status: 'idle' | 'loading' | 'authenticated' | 'unauthenticated';
  me: MeResponse | null;
  setLoading: () => void;
  setAuthenticated: (me: MeResponse) => void;
  setUnauthenticated: () => void;
};

export const useAuthStore = create<AuthState>((set) => ({
  status: 'idle',
  me: null,
  setLoading: () => set({ status: 'loading' }),
  setAuthenticated: (me) => set({ status: 'authenticated', me }),
  setUnauthenticated: () => set({ status: 'unauthenticated', me: null }),
}));
